import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(() => {
        ['assets/img/logo.png', 'assets/images/hero-carousel-image.png'].forEach((src) => {
          const img = new Image();
          img.src = src;
        });
      });
    }
  })
  .catch((err) => console.error('App startup error:', err));
